type SeparatorCandidate = {
  char: string
  label: string
}

export type ParsedInput = {
  lineCount: number
  separator: SeparatorCandidate | null
  headers: string[]
  rows: string[][]
}

export const SEPARATOR_CANDIDATES: SeparatorCandidate[] = [
  { char: '\t', label: 'tab (\\t)' },
  { char: ';', label: 'ponto e virgula (;)' },
  { char: ',', label: 'virgula (,)' },
  { char: '|', label: 'pipe (|)' },
]

export const TICKER_IMPORT_FIELDS = ['ticker', 'qtd', 'preco_medio', 'cnpj'] as const

export const HEADER_HINTS_BY_FIELD: Record<(typeof TICKER_IMPORT_FIELDS)[number], string[]> = {
  ticker: ['Nome ativo', 'Ticker', 'Ativo'],
  qtd: ['Quantidade', 'Qtd'],
  preco_medio: ['Preço médio (R$)', 'Preco medio (R$)', 'Preço médio', 'Preco medio'],
  cnpj: ['CNPJ'],
}

// Normaliza textos para comparação tolerante (acento/caixa/espaços).
export function normalizeLabel(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()
}

// Lê o mapeamento "campo=header" ignorando comentários e linhas inválidas.
export function parseMappingText(mappingText: string): Map<string, string> {
  const result = new Map<string, string>()
  const validFields = new Set<string>(TICKER_IMPORT_FIELDS)

  for (const line of mappingText.split(/\r?\n/)) {
    const normalized = line.trim()
    if (!normalized || normalized.startsWith('#') || !normalized.includes('=')) {
      continue
    }

    const [fieldPart, ...headerParts] = normalized.split('=')
    const field = fieldPart.trim()
    if (!validFields.has(field)) continue

    const header = headerParts.join('=').trim()
    if (!header) continue
    result.set(field, header)
  }

  return result
}

export function separatorToMappingValue(separator: SeparatorCandidate | null): string {
  if (!separator) return ''
  return separator.char === '\t' ? '\\t' : separator.char
}

function parseSeparatorToken(rawValue: string): string | null {
  const value = rawValue.trim()
  if (!value) return null

  if (value === '\\t' || value === 'tab' || value === 'tab(\\t)' || value === 'tab (\\t)') {
    return '\t'
  }

  if (value === ';' || value === ',' || value === '|') {
    return value
  }

  return null
}

export function parseSeparatorFromMappingText(mappingText: string): string | null {
  for (const line of mappingText.split(/\r?\n/)) {
    const normalized = line.trim()
    if (!normalized || normalized.startsWith('#') || !normalized.includes('=')) {
      continue
    }

    const [fieldPart, ...valueParts] = normalized.split('=')
    const field = fieldPart.trim().toLowerCase()
    if (field !== 'separator') continue

    return parseSeparatorToken(valueParts.join('=').trim())
  }

  return null
}
